import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Main from './components/main/Main';

ReactDOM.render(<Main />, document.getElementById('root'));
